module.exports = "<ul class=\"nav navbar-top-links navbar-right\">\n    <id-badge></id-badge>\n\n    <preferences></preferences>\n\n    <impersonate-user ng-if=\"AuthService.isImpersonating() || AuthService.hasPermission('impersonate-all-users') || AuthService.hasPermission('impersonate-support-workers')\"></impersonate-user>\n\n    <li>\n        <a ui-sref=\"auth.logout\">\n            <i class=\"fa fa-sign-out\"></i>\n            Log Out\n        </a>\n    </li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/js/directives/navbar/supportWorker/view.html
// module id = 951
// module chunks = 0